import { render, staticRenderFns } from "./CookiePrivacyBanner.vue?vue&type=template&id=90df9ede&"
import script from "./CookiePrivacyBanner.vue?vue&type=script&lang=js&"
export * from "./CookiePrivacyBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports